import React from "react"
import clsx from 'clsx'

class AssignToCategoryGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    var options = this.props.all_categories.map((option) => {
			return <option key={option.id} value={option.id}>{option.name}</option>
		});
    
    options.unshift(<option key={0} value="please_select_one" disabled>{I18n.t("please_select_one")}</option>)
    return(
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{I18n.t('category')}</label>
            <select className="form-control" name="category" value={this.props.category_id ? this.props.category_id : "please_select_one"} onChange={this.props.onChangeCategory}>
              {options}
            </select>
          </div>
        </div>
      </div>
    )
  }
}

export default AssignToCategoryGeneral
